/* tslint:disable */
/* eslint-disable */
/**
 * Oasisscan API
 * https://github.com/bitcat365/oasisscan-backend#readme
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DebondingDelegationRow
 */
export interface DebondingDelegationRow {
    /**
     * 
     * @type {string}
     * @memberof DebondingDelegationRow
     */
    validatorAddress: string;
    /**
     * 
     * @type {string}
     * @memberof DebondingDelegationRow
     */
    shares: string;
    /**
     * 
     * @type {number}
     * @memberof DebondingDelegationRow
     */
    debondEnd: number;
    /**
     * 
     * @type {number}
     * @memberof DebondingDelegationRow
     */
    epochLeft: number;
    /**
     * 
     * @type {string}
     * @memberof DebondingDelegationRow
     */
    validatorName: string | null;
    /**
     * 
     * @type {string}
     * @memberof DebondingDelegationRow
     */
    icon: string | null;
}

export function DebondingDelegationRowFromJSON(json: any): DebondingDelegationRow {
    return DebondingDelegationRowFromJSONTyped(json, false);
}

export function DebondingDelegationRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): DebondingDelegationRow {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'validatorAddress': json['validatorAddress'],
        'shares': json['shares'],
        'debondEnd': json['debondEnd'],
        'epochLeft': json['epochLeft'],
        'validatorName': json['validatorName'],
        'icon': json['icon'],
    };
}

export function DebondingDelegationRowToJSON(value?: DebondingDelegationRow | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'validatorAddress': value.validatorAddress,
        'shares': value.shares,
        'debondEnd': value.debondEnd,
        'epochLeft': value.epochLeft,
        'validatorName': value.validatorName,
        'icon': value.icon,
    };
}


